var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageUrl)?_c('div',{staticClass:"crop-simple-container"},[_c('div',{staticClass:"crop-box"},[_c('img',{ref:"cropImage",attrs:{"src":_vm.imageUrl,"alt":"裁剪原图"}})]),_vm._v(" "),_c('div',{staticClass:"crop-actions"},[_c('button',{staticClass:"confirm-btn",on:{"click":_vm.confirmCrop}},[_vm._v("确认裁剪")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74956554","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CropImage/index.vue
// module id = 2KZh
// module chunks = 3